import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TitledPageComponent } from 'src/app/shared/components/titled-page/titled-page.component';

@Component({
  selector: 'app-assignments',
  standalone: true,
  imports: [RouterOutlet, TitledPageComponent],
  templateUrl: './assignments.component.html',
  styleUrl: './assignments.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssignmentsComponent {}
